// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicDemographicsState = {
  ...DefaultState
}

export const topicDemographics = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicDemographicsState,
  actionRequest: ActionTypes.REQUEST_TOPIC_PLAN_DEMOGRAPHICS,
  actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_DEMOGRAPHICS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN_DEMOGRAPHICS,
  actionInvalidate: ActionTypes.INVALIDATE_TOPIC_PLAN_DEMOGRAPHICS
})
